module.exports = __webpack_public_path__ + "img/intro.a737189f.jpg";